import { z } from 'zod';
import { TicketSearchResultItemSchema } from './ticket-schemas.js';
// Shared between backend (controller DTOs) and frontend (apps/pwa /station
// route + api-client). valet-keychain-qr D1 — station-auth: a per-location,
// read-only device credential lets cashiers/supervisors look up cars
// without a personal PWA operator login.
// ── Device provisioning (org_admin / super_admin) ────────────────────────────
export const ProvisionStationDeviceRequestSchema = z.object({
    label: z.string().trim().min(1).max(120),
});
export const StationDeviceStatusSchema = z.enum(['active', 'revoked']);
export const ProvisionStationDeviceResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    locationId: z.string().uuid(),
    label: z.string(),
    status: z.literal('active'),
    createdAt: z.string(),
    lastUsedAt: z.null(),
    // The plaintext opaque device token — present ONLY in this response, once,
    // at provisioning time. Never returned again by any other endpoint.
    token: z.string(),
});
export const StationDeviceSummarySchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    locationId: z.string().uuid(),
    label: z.string(),
    status: StationDeviceStatusSchema,
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
});
export const ListStationDevicesResponseSchema = z.object({
    devices: z.array(StationDeviceSummarySchema),
});
// ── Station session exchange (device token → short-lived station JWT) ───────
export const StationSessionRequestSchema = z.object({
    token: z.string().trim().min(1),
});
export const StationSessionResponseSchema = z.object({
    accessToken: z.string(),
    expiresIn: z.number().int().positive(),
    locationId: z.string().uuid(),
    organizationId: z.string().uuid(),
});
// ── Station lookup (read-only, station-JWT guarded) ──────────────────────────
export const StationLookupQuerySchema = z.object({
    q: z.string().trim().min(1).max(200),
});
// Reuses the SAME result shape the PWA's operator-facing search already
// renders (TicketSearchResultItemSchema) — the station surface is a
// read-only subset of the same capability, not a new data shape.
export const StationLookupResponseSchema = z.object({
    results: z.array(TicketSearchResultItemSchema),
});
//# sourceMappingURL=station-schemas.js.map